<template>
  <Row>
    <i-col span="8">
      <StringDatePicker :value="date" type="date" @on-change="updateDate" style="width:100%"></StringDatePicker>
    </i-col>
    <i-col span="16">
      <i-select v-model="accuracy" @on-change="updateAccuracy" style="padding-left:6px">
        <i-option value="Day">Day</i-option>
        <i-option value="Month">Month</i-option>
        <i-option value="Year">Year</i-option>
      </i-select>
    </i-col>
  </Row>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    value: {
      type: Object,
    },
  },

  data() {
    return {
      date: this.value && this.value.date,
      accuracy: this.value && this.value.accuracy,
    };
  },

  watch: {
    value() {
      if (this.value) {
        this.date = this.value.date;
        this.accuracy = this.value.accuracy;
      }
    },
  },
  computed: {
    fullDate() {
      let value = {
        date: this.date,
        accuracy: this.accuracy,
      };
      return value;
    },
  },
  methods: {
    updateDate(value) {
      this.date = value.toString();
      if (_.isEmpty(this.date)) {
        this.accuracy = null;
      } else if (_.isEmpty(this.accuracy)) {
        this.accuracy = "Day";
      }
      this.$emit("input", this.fullDate);
    },
    updateAccuracy(value) {
      if (_.isEmpty(this.date)) {
        this.accuracy = "";
      } else {
        this.accuracy = value;
      }
      this.$emit("input", this.fullDate);
    },
  },
};
</script>

<style lang="css"></style>
